import { CONFIG } from 'constants/config';

export function isChristmasSeason() {
  return CONFIG.SEASONAL.CHRISTMAS_ENABLED;
}

export function isSnowfallEnabled() {
  return CONFIG.SEASONAL.SNOWFALL_ENABLED;
}

export function isEasterSeason() {
  return CONFIG.SEASONAL.EASTER_ENABLED;
}

export const getHolidayImageSrc = ({ christmasIcon, easterIcon }: {christmasIcon?: string, easterIcon?: string}) => {
  if (isChristmasSeason() && christmasIcon) {
    return christmasIcon;
  }
  if (isEasterSeason() && easterIcon) {
    return easterIcon;
  }
  return '';
};
